// signalConstants.ts
// Shared signal label and color maps — used by SignalsPanel, SignalTooltip, etc.

export const TRADER_GROUP_COLORS: Record<string, string> = {
    insider: '#f59e0b',
    winner: '#10b981',
    whale: '#6366f1',
    none: '#6b7280',
};

export const TRADER_GROUP_LABELS: Record<string, string> = {
    insider: 'Insider',
    winner: 'Winner',
    whale: 'Whale',
    none: 'General',
};

export const SIGNAL_TYPE_LABELS: Record<string, string> = {
    position_opened: 'Position Opened',
    position_closed: 'Position Closed',
    probability_spike: 'Prob. Spike',
    probability_change: 'Prob. Change',
    conviction_shift: 'Conviction Shift',
    volume_surge: 'Volume Surge',
    volume_anomaly: 'Vol. Anomaly',
    activity_surge: 'Activity Surge',
    buy_sell_imbalance: 'Buy/Sell Imbalance',
    large_trade: 'Large Trade',
    watchlist_entry: 'Watchlist Entry',
};

export const SIGNAL_TYPE_SHORT: Record<string, string> = {
    position_opened: 'Pos. Open',
    position_closed: 'Pos. Close',
    probability_spike: 'Spike',
    probability_change: 'Prob Δ',
    conviction_shift: 'Conviction',
    volume_surge: 'Vol. Surge',
    volume_anomaly: 'Vol. Anom.',
    activity_surge: 'Activity',
    buy_sell_imbalance: 'Imbalance',
    large_trade: 'Lg. Trade',
    watchlist_entry: 'Watchlist',
};
